export const unauthorizedMessage = "No valid session was supplied.";

export const accountRequiredMessage = "Connect an account to continue.";

/** The refusal every `session` and `account` route declares. */
export const sessionRequired = {
  UNAUTHORIZED: { message: unauthorizedMessage },
} as const;

/** The refusals every route that accepts a Pax service access token declares. */
export const serviceRefusals = {
  UNAUTHORIZED: { message: "A valid service access token is required." },
  FORBIDDEN: { message: "The access token's caller or scope does not grant this route." },
} as const;
